// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector('form');
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//         this.cart =
//           document.querySelector('cart-notification') ||
//           document.querySelector('cart-drawer');
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector('span');

//         if (document.querySelector('cart-drawer')) {
//           this.submitButton.setAttribute('aria-haspopup', 'dialog');
//         }

//         this.hideErrors = this.dataset.hideErrors === 'true';

//         this.createMcLarenModal();
//       }

//       hasMcLarenOverride() {
//         const tags = Array.isArray(window.mclarenCustomerTags)
//           ? window.mclarenCustomerTags
//           : [];

//         return tags.some(
//           (tag) => String(tag).toLowerCase() === 'mclaren-override'
//         );
//       }

//       getMcLarenDefaultMessage() {
//         return `
//           <p>
//             If you’re looking to order McLaren in bulk
//             <strong>(more than 3 units per item)</strong>,
//             please reach out to
//             <a href="mailto:admin@whitestonebranding.com">
//               admin@whitestonebranding.com
//             </a>
//             and we’ll be happy to help open a bulk order request for you!
//           </p>

//           <p>
//             Please note: Bulk McLaren orders typically require
//             <strong>4–6 weeks for production.</strong>
//             If you have a special or time-sensitive request, please let us know
//             and we’ll do our best to accommodate!
//           </p>
//         `;
//       }

//       cacheMcLarenModalRefs(modal) {
//         this.mclarenModal = modal;
//         this.mclarenModalClose = modal.querySelector(
//           '.mclaren-bulk-modal__close'
//         );
//         this.mclarenModalButton = modal.querySelector(
//           '.mclaren-bulk-modal__button'
//         );
//         this.mclarenModalOverlay = modal.querySelector(
//           '.mclaren-bulk-modal__overlay'
//         );
//         this.mclarenModalTitle = modal.querySelector(
//           '#McLarenBulkOrderModalTitle'
//         );
//         this.mclarenModalMessage = modal.querySelector(
//           '.mclaren-bulk-modal__message'
//         );
//       }

//       createMcLarenModal() {
//         const existingModal = document.getElementById('McLarenBulkOrderModal');

//         // Reuse a modal created by CartItems or another ProductForm.
//         // Its click listeners are already attached by whoever created it.
//         if (existingModal) {
//           this.cacheMcLarenModalRefs(existingModal);
//           this.bindMcLarenEscape();
//           return;
//         }

//         const modal = document.createElement('div');

//         modal.id = 'McLarenBulkOrderModal';
//         modal.className = 'mclaren-bulk-modal';
//         modal.setAttribute('role', 'dialog');
//         modal.setAttribute('aria-modal', 'true');
//         modal.setAttribute('aria-labelledby', 'McLarenBulkOrderModalTitle');
//         modal.hidden = true;

//         modal.innerHTML = `
//           <div class="mclaren-bulk-modal__overlay"></div>

//           <div class="mclaren-bulk-modal__content">
//             <button
//               type="button"
//               class="mclaren-bulk-modal__close"
//               aria-label="Close"
//             >
//               &times;
//             </button>

//             <div class="mclaren-bulk-modal__icon">
//               <span>!</span>
//             </div>

//             <h2 id="McLarenBulkOrderModalTitle">
//               Bulk Order Request
//             </h2>

//             <div class="mclaren-bulk-modal__message">
//               ${this.getMcLarenDefaultMessage()}
//             </div>

//             <button
//               type="button"
//               class="mclaren-bulk-modal__button"
//             >
//               Got it
//             </button>
//           </div>
//         `;

//         document.body.appendChild(modal);

//         this.cacheMcLarenModalRefs(modal);

//         this.mclarenModalClose.addEventListener('click', () => {
//           this.closeMcLarenModal();
//         });

//         this.mclarenModalButton.addEventListener('click', () => {
//           this.closeMcLarenModal();
//         });

//         this.mclarenModalOverlay.addEventListener('click', () => {
//           this.closeMcLarenModal();
//         });

//         this.bindMcLarenEscape();

//         if (!document.getElementById('mclaren-bulk-modal-styles')) {
//           const style = document.createElement('style');

//           style.id = 'mclaren-bulk-modal-styles';

//           style.textContent = `
//             .mclaren-bulk-modal {
//               position: fixed;
//               inset: 0;
//               z-index: 9999;
//               display: flex;
//               align-items: center;
//               justify-content: center;
//               padding: 20px;
//             }

//             .mclaren-bulk-modal[hidden] {
//               display: none;
//             }

//             .mclaren-bulk-modal__overlay {
//               position: absolute;
//               inset: 0;
//               background: rgba(0, 0, 0, 0.45);
//               cursor: pointer;
//             }

//             .mclaren-bulk-modal__content {
//               position: relative;
//               z-index: 1;
//               width: 100%;
//               max-width: 520px;
//               max-height: calc(100vh - 40px);
//               overflow-y: auto;
//               padding: 36px 36px 32px;
//               background: #fff;
//               border-radius: 8px;
//               box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
//               text-align: center;
//               animation: mclarenModalIn 0.2s ease-out;
//             }

//             .mclaren-bulk-modal__close {
//               position: absolute;
//               top: 12px;
//               right: 14px;
//               width: 36px;
//               height: 36px;
//               padding: 0;
//               border: 0;
//               background: transparent;
//               font-size: 28px;
//               line-height: 1;
//               color: #333;
//               cursor: pointer;
//             }

//             .mclaren-bulk-modal__close:hover {
//               opacity: 0.7;
//             }

//             .mclaren-bulk-modal__icon {
//               display: flex;
//               align-items: center;
//               justify-content: center;
//               width: 48px;
//               height: 48px;
//               margin: 0 auto 18px;
//               border-radius: 50%;
//               background: #f1f1f1;
//               color: #111;
//               font-size: 24px;
//               font-weight: 600;
//             }

//             .mclaren-bulk-modal__content h2 {
//               margin: 0 0 18px;
//               font-size: 24px;
//               line-height: 1.2;
//             }

//             .mclaren-bulk-modal__message {
//               color: #333;
//               font-size: 15px;
//               line-height: 1.6;
//             }

//             .mclaren-bulk-modal__message p {
//               margin: 0 0 16px;
//             }

//             .mclaren-bulk-modal__message p:last-child {
//               margin-bottom: 24px;
//             }

//             .mclaren-bulk-modal__message a {
//               color: inherit;
//               text-decoration: underline;
//               font-weight: 600;
//             }

//             .mclaren-bulk-modal__button {
//               width: 100%;
//               min-height: 48px;
//               padding: 12px 24px;
//               border: 0;
//               border-radius: 4px;
//               background: #111;
//               color: #fff;
//               font-size: 15px;
//               font-weight: 600;
//               cursor: pointer;
//             }

//             .mclaren-bulk-modal__button:hover {
//               opacity: 0.9;
//             }

//             .mclaren-bulk-modal__button:disabled {
//               opacity: 0.6;
//               cursor: not-allowed;
//             }

//             @keyframes mclarenModalIn {
//               from {
//                 opacity: 0;
//                 transform: translateY(8px);
//               }

//               to {
//                 opacity: 1;
//                 transform: translateY(0);
//               }
//             }

//             @media screen and (max-width: 749px) {
//               .mclaren-bulk-modal {
//                 padding: 16px;
//               }

//               .mclaren-bulk-modal__content {
//                 padding: 32px 22px 24px;
//                 max-height: calc(100vh - 32px);
//               }

//               .mclaren-bulk-modal__content h2 {
//                 font-size: 21px;
//               }

//               .mclaren-bulk-modal__message {
//                 font-size: 14px;
//               }
//             }
//           `;

//           document.head.appendChild(style);
//         }
//       }

//       bindMcLarenEscape() {
//         // Register once per page, no matter how many product forms exist.
//         if (window.mclarenEscapeBound) return;
//         window.mclarenEscapeBound = true;

//         document.addEventListener('keydown', (event) => {
//           if (event.key !== 'Escape') return;

//           const modal = document.getElementById('McLarenBulkOrderModal');
//           if (!modal || modal.hidden) return;

//           // Route through the close button so whichever component owns
//           // the modal (CartItems or ProductForm) runs its own close logic.
//           const closeButton = modal.querySelector('.mclaren-bulk-modal__close');
//           if (closeButton) closeButton.click();
//         });
//       }

//       openMcLarenModal() {
//         if (!this.mclarenModal || !document.body.contains(this.mclarenModal)) {
//           this.createMcLarenModal();
//         }

//         if (!this.mclarenModal) return;

//         // Restore the standard bulk-order content in case the cart
//         // changed it (e.g. "Please Update Your Cart").
//         if (this.mclarenModalTitle) {
//           this.mclarenModalTitle.textContent = 'Bulk Order Request';
//         }

//         if (this.mclarenModalMessage) {
//           this.mclarenModalMessage.innerHTML = this.getMcLarenDefaultMessage();
//         }

//         if (this.mclarenModalButton) {
//           this.mclarenModalButton.textContent = 'Got it';
//           this.mclarenModalButton.disabled = false;
//         }

//         this.mclarenModal.hidden = false;
//         document.body.classList.add('mclaren-modal-open');

//         this.mclarenModalButton?.focus();
//       }

//       closeMcLarenModal() {
//         if (!this.mclarenModal) return;

//         this.mclarenModal.hidden = true;
//         document.body.classList.remove('mclaren-modal-open');
//       }

//       async isMcLarenLimitExceeded(quantity) {
//         if (this.dataset.mclaren !== 'true') {
//           return false;
//         }

//         if (this.hasMcLarenOverride()) {
//           return false;
//         }

//         const productId = this.dataset.productId;

//         try {
//           const response = await fetch(`${routes.cart_url}.js`);
//           const cart = await response.json();

//           let currentQuantity = 0;

//           cart.items.forEach((item) => {
//             if (String(item.product_id) === String(productId)) {
//               currentQuantity += item.quantity;
//             }
//           });

//           return currentQuantity + quantity > 3;
//         } catch (error) {
//           console.error('Unable to check McLaren quantity limit:', error);
//           return false;
//         }
//       }

//       async onSubmitHandler(evt) {
//         evt.preventDefault();

//         if (this.submitButton.getAttribute('aria-disabled') === 'true') {
//           return;
//         }

//         const formData = new FormData(this.form);
//         const quantity = parseInt(formData.get('quantity')) || 1;

//         const exceedsMcLarenLimit = await this.isMcLarenLimitExceeded(quantity);

//         if (exceedsMcLarenLimit) {
//           this.openMcLarenModal();
//           return;
//         }

//         this.handleErrorMessage();

//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }

//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });

//               this.handleErrorMessage(response.description);

//               const soldOutMessage =
//                 this.submitButton.querySelector('.sold-out-message');

//               if (!soldOutMessage) return;

//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButtonText.classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//             const startMarker = CartPerformance.createStartingMarker(
//               'add:wait-for-subscribers'
//             );

//             if (!this.error) {
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               }).then(() => {
//                 CartPerformance.measureFromMarker(
//                   'add:wait-for-subscribers',
//                   startMarker
//                 );
//               });
//             }

//             this.error = false;

//             const quickAddModal = this.closest('quick-add-modal');

//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     CartPerformance.measure('add:paint-updated-sections', () => {
//                       this.cart.renderContents(response);
//                     });
//                   });
//                 },
//                 { once: true }
//               );

//               quickAddModal.hide(true);
//             } else {
//               CartPerformance.measure('add:paint-updated-sections', () => {
//                 this.cart.renderContents(response);
//               });
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');

//             if (this.cart && this.cart.classList.contains('is-empty')) {
//               this.cart.classList.remove('is-empty');
//             }

//             if (!this.error) {
//               this.submitButton.removeAttribute('aria-disabled');
//             }

//             this.querySelector('.loading__spinner').classList.add('hidden');

//             CartPerformance.measureFromEvent('add:user-action', evt);
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper ||
//           this.querySelector('.product-form__error-message-wrapper');

//         if (!this.errorMessageWrapper) return;

//         this.errorMessage =
//           this.errorMessage ||
//           this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute('disabled', 'disabled');

//           if (text) {
//             this.submitButtonText.textContent = text;
//           }
//         } else {
//           this.submitButton.removeAttribute('disabled');
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector('[name=id]');
//       }
//     }
//   );
// }
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.createMcLarenModal();
      }

      hasMcLarenOverride() {
        // Primary source: rendered server-side on <product-form>
        // in buy-buttons.liquid.
        if (this.dataset.mclarenOverride === 'true') {
          return true;
        }

        // Fallback: global tags from theme.liquid.
        const tags = Array.isArray(window.mclarenCustomerTags)
          ? window.mclarenCustomerTags
          : [];

        return tags.some(
          (tag) => String(tag).trim().toLowerCase() === 'mclaren-override'
        );
      }

      getMcLarenDefaultMessage() {
        return `
          <p>
            If you’re looking to order McLaren in bulk
            <strong>(more than 3 units per item)</strong>,
            please reach out to
            <a href="mailto:admin@whitestonebranding.com">
              admin@whitestonebranding.com
            </a>
            and we’ll be happy to help open a bulk order request for you!
          </p>

          <p>
            Please note: Bulk McLaren orders typically require
            <strong>4–6 weeks for production.</strong>
            If you have a special or time-sensitive request, please let us know
            and we’ll do our best to accommodate!
          </p>
        `;
      }

      cacheMcLarenModalRefs(modal) {
        this.mclarenModal = modal;
        this.mclarenModalClose = modal.querySelector(
          '.mclaren-bulk-modal__close'
        );
        this.mclarenModalButton = modal.querySelector(
          '.mclaren-bulk-modal__button'
        );
        this.mclarenModalOverlay = modal.querySelector(
          '.mclaren-bulk-modal__overlay'
        );
        this.mclarenModalTitle = modal.querySelector(
          '#McLarenBulkOrderModalTitle'
        );
        this.mclarenModalMessage = modal.querySelector(
          '.mclaren-bulk-modal__message'
        );
      }

      createMcLarenModal() {
        const existingModal = document.getElementById('McLarenBulkOrderModal');

        // Reuse a modal created by CartItems or another ProductForm.
        // Its listeners read state from the modal element, so they behave
        // the same no matter who created it.
        if (existingModal) {
          this.cacheMcLarenModalRefs(existingModal);
          this.bindMcLarenEscape();
          return;
        }

        const modal = document.createElement('div');

        modal.id = 'McLarenBulkOrderModal';
        modal.className = 'mclaren-bulk-modal';
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-labelledby', 'McLarenBulkOrderModalTitle');
        modal.dataset.mode = 'default';
        modal.mclarenAction = null;
        modal.hidden = true;

        modal.innerHTML = `
          <div class="mclaren-bulk-modal__overlay"></div>

          <div class="mclaren-bulk-modal__content">
            <button
              type="button"
              class="mclaren-bulk-modal__close"
              aria-label="Close"
            >
              &times;
            </button>

            <div class="mclaren-bulk-modal__icon">
              <span>!</span>
            </div>

            <h2 id="McLarenBulkOrderModalTitle">
              Bulk Order Request
            </h2>

            <div class="mclaren-bulk-modal__message">
              ${this.getMcLarenDefaultMessage()}
            </div>

            <button
              type="button"
              class="mclaren-bulk-modal__button"
            >
              Got it
            </button>
          </div>
        `;

        document.body.appendChild(modal);

        this.cacheMcLarenModalRefs(modal);

        // × and overlay: ignored while in cleanup mode.
        this.mclarenModalClose.addEventListener('click', () => {
          this.dismissMcLarenModal();
        });

        this.mclarenModalOverlay.addEventListener('click', () => {
          this.dismissMcLarenModal();
        });

        // Main button: run the modal's current action if it has one
        // (e.g. the cart's "Update Cart" cleanup), otherwise close.
        this.mclarenModalButton.addEventListener('click', async () => {
          const action = modal.mclarenAction;

          if (typeof action === 'function') {
            await action();
            return;
          }

          this.closeMcLarenModal();
        });

        this.bindMcLarenEscape();

        if (!document.getElementById('mclaren-bulk-modal-styles')) {
          const style = document.createElement('style');

          style.id = 'mclaren-bulk-modal-styles';

          style.textContent = `
            .mclaren-bulk-modal {
              position: fixed;
              inset: 0;
              z-index: 9999;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 20px;
            }

            .mclaren-bulk-modal[hidden] {
              display: none;
            }

            .mclaren-bulk-modal__overlay {
              position: absolute;
              inset: 0;
              background: rgba(0, 0, 0, 0.45);
              cursor: pointer;
            }

            .mclaren-bulk-modal__content {
              position: relative;
              z-index: 1;
              width: 100%;
              max-width: 520px;
              max-height: calc(100vh - 40px);
              overflow-y: auto;
              padding: 36px 36px 32px;
              background: #fff;
              border-radius: 8px;
              box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
              text-align: center;
              animation: mclarenModalIn 0.2s ease-out;
            }

            .mclaren-bulk-modal__close {
              position: absolute;
              top: 12px;
              right: 14px;
              width: 36px;
              height: 36px;
              padding: 0;
              border: 0;
              background: transparent;
              font-size: 28px;
              line-height: 1;
              color: #333;
              cursor: pointer;
            }

            .mclaren-bulk-modal__close[hidden] {
              display: none;
            }

            .mclaren-bulk-modal__close:hover {
              opacity: 0.7;
            }

            .mclaren-bulk-modal__icon {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 48px;
              height: 48px;
              margin: 0 auto 18px;
              border-radius: 50%;
              background: #f1f1f1;
              color: #111;
              font-size: 24px;
              font-weight: 600;
            }

            .mclaren-bulk-modal__content h2 {
              margin: 0 0 18px;
              font-size: 24px;
              line-height: 1.2;
            }

            .mclaren-bulk-modal__message {
              color: #333;
              font-size: 15px;
              line-height: 1.6;
            }

            .mclaren-bulk-modal__message p {
              margin: 0 0 16px;
            }

            .mclaren-bulk-modal__message p:last-child {
              margin-bottom: 24px;
            }

            .mclaren-bulk-modal__message a {
              color: inherit;
              text-decoration: underline;
              font-weight: 600;
            }

            .mclaren-bulk-modal__button {
              width: 100%;
              min-height: 48px;
              padding: 12px 24px;
              border: 0;
              border-radius: 4px;
              background: #111;
              color: #fff;
              font-size: 15px;
              font-weight: 600;
              cursor: pointer;
            }

            .mclaren-bulk-modal__button:hover {
              opacity: 0.9;
            }

            .mclaren-bulk-modal__button:disabled {
              opacity: 0.6;
              cursor: not-allowed;
            }

            @keyframes mclarenModalIn {
              from {
                opacity: 0;
                transform: translateY(8px);
              }

              to {
                opacity: 1;
                transform: translateY(0);
              }
            }

            @media screen and (max-width: 749px) {
              .mclaren-bulk-modal {
                padding: 16px;
              }

              .mclaren-bulk-modal__content {
                padding: 32px 22px 24px;
                max-height: calc(100vh - 32px);
              }

              .mclaren-bulk-modal__content h2 {
                font-size: 21px;
              }

              .mclaren-bulk-modal__message {
                font-size: 14px;
              }
            }
          `;

          document.head.appendChild(style);
        }
      }

      bindMcLarenEscape() {
        // Register once per page, no matter how many product forms exist.
        if (window.mclarenEscapeBound) return;
        window.mclarenEscapeBound = true;

        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;

          const modal = document.getElementById('McLarenBulkOrderModal');
          if (!modal || modal.hidden) return;

          // Cart cleanup is required; Escape does nothing.
          if (modal.dataset.mode === 'cleanup') return;

          // Route through the close button so whichever component owns
          // the modal runs its own close logic.
          const closeButton = modal.querySelector('.mclaren-bulk-modal__close');
          if (closeButton) closeButton.click();
        });
      }

      setMcLarenModalMode(mode) {
        if (!this.mclarenModal) return;

        const isCleanup = mode === 'cleanup';

        this.mclarenModal.dataset.mode = isCleanup ? 'cleanup' : 'default';

        if (this.mclarenModalClose) {
          this.mclarenModalClose.hidden = isCleanup;
        }

        if (this.mclarenModalOverlay) {
          this.mclarenModalOverlay.style.cursor = isCleanup ? 'default' : '';
        }

        if (!isCleanup) {
          this.mclarenModal.mclarenAction = null;
        }
      }

      openMcLarenModal() {
        if (!this.mclarenModal || !document.body.contains(this.mclarenModal)) {
          this.createMcLarenModal();
        }

        if (!this.mclarenModal) return;

        // Never interrupt a required cart cleanup.
        if (
          !this.mclarenModal.hidden &&
          this.mclarenModal.dataset.mode === 'cleanup'
        ) {
          return;
        }

        this.setMcLarenModalMode('default');

        // Restore the standard bulk-order content in case the cart
        // changed it (e.g. "Please Update Your Cart").
        if (this.mclarenModalTitle) {
          this.mclarenModalTitle.textContent = 'Bulk Order Request';
        }

        if (this.mclarenModalMessage) {
          this.mclarenModalMessage.innerHTML = this.getMcLarenDefaultMessage();
        }

        if (this.mclarenModalButton) {
          this.mclarenModalButton.textContent = 'Got it';
          this.mclarenModalButton.disabled = false;
        }

        this.mclarenModal.hidden = false;
        document.body.classList.add('mclaren-modal-open');

        this.mclarenModalButton?.focus();
      }

      // User-initiated close (× / overlay).
      // Ignored while the cart cleanup is required.
      dismissMcLarenModal() {
        if (!this.mclarenModal) return;

        if (this.mclarenModal.dataset.mode === 'cleanup') {
          this.mclarenModalButton?.focus();
          return;
        }

        this.closeMcLarenModal();
      }

      // Programmatic close. Always closes and resets to default mode.
      closeMcLarenModal() {
        if (!this.mclarenModal) return;

        this.mclarenModal.hidden = true;
        this.setMcLarenModalMode('default');
        document.body.classList.remove('mclaren-modal-open');

        if (this.mclarenModalButton) {
          this.mclarenModalButton.disabled = false;
        }
      }

      async isMcLarenLimitExceeded(quantity) {
        if (this.dataset.mclaren !== 'true') {
          return false;
        }

        if (this.hasMcLarenOverride()) {
          return false;
        }

        const productId = this.dataset.productId;

        try {
          const response = await fetch(`${routes.cart_url}.js`);
          const cart = await response.json();

          let currentQuantity = 0;

          cart.items.forEach((item) => {
            if (String(item.product_id) === String(productId)) {
              currentQuantity += item.quantity;
            }
          });

          return currentQuantity + quantity > 3;
        } catch (error) {
          console.error('Unable to check McLaren quantity limit:', error);
          return false;
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        const formData = new FormData(this.form);
        const quantity = parseInt(formData.get('quantity')) || 1;

        const exceedsMcLarenLimit = await this.isMcLarenLimitExceeded(quantity);

        if (exceedsMcLarenLimit) {
          this.openMcLarenModal();
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');

              if (!soldOutMessage) return;

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
              'add:wait-for-subscribers'
            );

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');

          if (text) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}